// React Dependencies
import React from 'react';

// External Dependencies
import { Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';

// Internal Dependencies
import PopularTagsTable from './table';
import MText from '../../common/MText';
import Colours from '../../../styles/colours';

const TagsPopularTagList = () => (
  <div>
    <div className="justify-content-start content-header mb-3">
      <Link to="/admin/tags" className="d-flex align-items-center">
        <Icon className="back">arrow_back</Icon>
      </Link>
      <MText variant="h1" text="Popular Tags" bold colour={Colours.Gray6} />
    </div>

    <PopularTagsTable />
  </div>
);

export default TagsPopularTagList;
